import queryString from 'query-string';

export const appendQueryString = (url, params) =>
  url + (url.includes('?') ? '&' : '?') + queryString.stringify(params);
